<template>
  <div class="record-chart">
    <div class="record-table">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="pledgeTableRef"
        class="vxe-table-element"
        cell-class-name="multiple-select"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @edit-actived="editActivedEvent"
        :data="tableData"
        :edit-rules="tableRules"
        :toolbar="{}"
        :footer-method="footerMethod"
        show-footer
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
      >
        <template v-slot:buttons>
          <el-button
            @click="$refs.pledgeTableRef.commitProxy('insert_actived')"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >新增</el-button
          >
          <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columns"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          height="100%"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'goodsType'">{{
              getName('goodsType', row[item.field])
            }}</span>
            <span v-else-if="item.field == 'goodsCategory'">{{
              getName('goodsCategory', row[item.field])
            }}</span>
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <!--根据表格的tableColumnList显示在编辑状态下不同的控件-->
          <template v-slot:edit="{ row }">
            <search-table
              v-if="item.editRender.name == 'goodsType'"
              ref="searchTable"
              disabled
              v-model="row.goodsType"
              searchType="product"
              :isMultiple="true"
              :currentValue="getName('goodsType', row.goodsType)"
              :checkRowKeys="[row.goodsType] || []"
              :extraData="{
                parentProductStatus: 'ZT03',
                selectCompanyCode: userInfo.companyCode,
                adminFlag: userInfo.adminFlag,
              }"
              @input="(val) => changeCargoTypeHandler(row, val)"
            ></search-table>
            <search-table
              v-else-if="item.editRender.name == 'goodsCategory'"
              ref="searchTable"
              v-model="row.goodsCategory"
              disabled
              searchType="goodsDetail"
              :isMultiple="true"
              :currentValue="getName('goodsCategory', row.goodsCategory)"
              :checkRowKeys="[row.goodsCategory] || []"
              :extraData="{
                parentProductStatus: 'ZT03',
                productParentCodes: [row.goodsType],
              }"
              @input="(val) => changeCargoCategoryHandler(row, val)"
            ></search-table>
            <el-select
              v-else-if="item.editRender.name == 'select'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="(val) => handleRowIndexChange(val, row)"
            >
              <el-option
                v-for="(item, index) in collateralTableData"
                :key="index"
                :label="item.rowIndex"
                :value="item.rowIndex"
              ></el-option>
            </el-select>
            <el-input
              v-else-if="item.editRender.name == 'goodsModel'"
              disabled
              v-model="row[item.field]"
            >
            </el-input>
            <el-input v-else-if="item.editRender.name == 'input'" v-model="row[item.field]">
            </el-input>
            <el-input-number
              :precision="2"
              :min="0"
              :controls="false"
              v-else-if="item.editRender.name == 'quantity'"
              v-model="row[item.field]"
            ></el-input-number>
            <el-date-picker
              v-else-if="item.editRender.name == 'date'"
              clearable
              style="width: 100%"
              v-model="row[item.field]"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { chartColumns } from './index.js';
  import goodsApi from '@/api/masterData/goods.js';
  // import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'samplingTable',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      billStatus: {
        type: String,
        default: '',
      },
      collateralLst: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        columns: [],
        goodsTypeList: [], // 货物品类
        goodsCategoryList: [], //
        goodsCategoryAll: [],
        pricingStandardList: [],
        pricingUnitList: [],
        deleteCheckLineIds: [],
        goods: [],
        category: [],
        isDisabled: false,
        status: '',
        goodsValueFlag: 0,
        ids: [], // 被删除的数据id集合
        isDisabledGoods: false,
        safeWeight: 0,
        checkQuantity: 0,
        collateralTableData: [],
      };
    },
    mounted() {
      this.status = this.$route.query?.status;
      if (this.status == 'detail' || this.status == 'approval') {
        this.isDisabled = true;
        this.isDisabledGoods = true;
      } else {
        this.isDisabled = false;
      }
      this.columns = chartColumns(this);
      this.getGoodsParentApi(); // 获取商品大类
      this.getGoodsCategoryAll(); //获取全部商品品类
    },
    computed: {
      tableRules() {
        const checkQuantityValid = (rule, cellValue, callback, { row }) => {
          console.log(rule, cellValue);
          if (parseFloat(row['checkQuantity']) >= parseFloat(row['safeWeight'])) {
            callback(new Error('抽检重量/数量不能大于实际安全重量/数量'));
          } else {
            callback();
          }
        };
        return {
          checkQuantity: [
            { required: true, message: '抽检重量/数量必填', trigger: ['change', 'blur'] },
            { validator: checkQuantityValid },
          ],
        };
      },
    },
    methods: {
      changeCargoTypeHandler(row, val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        row.goodsType = rowData.parentProductNo;
        row.goodsTypeName = rowData.productChName;
        row.goodsCategory = '';
        row.goodsCategoryName = '';
        row.goodsModel = '';
      },
      changeCargoCategoryHandler(row, val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        row.goodsCategory = rowData.productDetailCode;
        console.log(rowData);
        row.goodsCategoryName = rowData.productChName;
        row.goodsModel = rowData.detailProductModel;
      },
      // 选中行
      handleSelectionChange({ selection }) {
        this.selectionList = selection;
      },
      // 删除行
      deleteRowHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.selectionList = [];
      },
      // 得到表格数据
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      // 计算和
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += parseFloat(item[field]);
        });
        return count;
      },
      // 表尾合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['checkQuantity'].includes(column.property)) {
              const result = this.sumNum(data, column.property);
              if (result) {
                return result;
              }
              return null;
            }
            return null;
          }),
        ];
      },
      // 获取货物大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 获取全部货物品类
      async getGoodsCategoryAll() {
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsCategoryAll = data.data;
        } else {
          console.error('获取货物品类数据失败');
        }
      },
      // 货物类型切换时更新级联的下拉数据
      async goodsTypeChange(row) {
        row.goodsCategory = '';
        this.updateCategory(row);
      },
      // 根据选择的货物类型更新货物品类下拉
      updateCategory(row) {
        const goodsType = row.goodsType;
        if (goodsType) {
          const productParentCode = this.goodsTypeList
            .filter((item) => goodsType.includes(item.value))
            .map((item) => item.value);
          const item = this.goodsCategoryAll.filter(
            (item) => item.productParentCode == productParentCode
          );
          if (item) {
            this.goodsCategoryList = item.map((item) => {
              return {
                value: item.productDetailCode,
                label: item.productChName,
              };
            });
          }
        }
      },
      // 表格行激活时处理函数
      editActivedEvent({ row }) {
        this.updateCategory(row);
      },
      // 获取验证后的表格数据
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.pledgeTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            if (valid) {
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                };
              });
              resolve({ tableData: formTableData, deleteCheckLineIds: this.ids });
            } else {
              this.$message.error('请填写表格数据');
              reject({ tableData: [], deleteCheckLineIds: [] });
            }
          });
        });
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.pledgeTableRef;
        return $table.getTableData().fullData;
      },
      // 表格退出编辑
      editClosedEvent() {
        this.tableData = this.getTableData();
      },
      // 替换显示表格中value为label
      getName(type, value) {
        if (value == null) {
          return '';
        }
        let item;
        if (type == 'goodsType') {
          if (!this.goodsTypeList.length) {
            return '';
          }
          item = this.goodsTypeList.find((item) => item.value == value);
          return item?.label;
        } else if (type == 'goodsCategory') {
          if (!this.goodsCategoryAll.length || value == '') {
            return;
          } else {
            item = this.goodsCategoryAll.find((item) => item.productDetailCode == value);
            return item?.productChName;
          }
        }
      },
      // 将数组转换为字符串
      arrayToString(array) {
        let str = '';
        array.forEach((element) => {
          str += element + ',';
        });
        str = str.substring(0, str.length - 1);
        return str;
      },

      // 选择质物信息行号
      handleRowIndexChange(val, row) {
        console.log(val, row, '---->>');
        const currentItem = this.collateralTableData.find((item) => item.rowIndex == val);
        console.log(JSON.stringify(currentItem), '选中的');
        row['goodsType'] = currentItem['goodsType'];
        row['goodsTypeName'] = currentItem['goodsTypeName'];
        row['goodsCategory'] = currentItem['goodsCategory'];
        row['goodsCategoryName'] = currentItem['goodsCategoryName'];
        row['goodsModel'] = currentItem['goodsModel'];
        row['collateralNo'] = val;
        row['collateralId'] = currentItem['id'];
        row['safeWeight'] = currentItem['safeWeight'];
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log('val', val);
          if (val && val.length) {
            this.fullTableData(val);
            val.forEach((item) => {
              this.goods.push(item.goodsType);
            });
          }
        },
        immediate: true,
      },
      collateralLst: {
        handler(val) {
          console.log('监听抽检信息表格数据', val);
          if (val && val.length) {
            this.collateralTableData = val?.map((item, index) => {
              return {
                ...item,
                rowIndex: index + 1,
              };
            });
          }
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .record-chart {
    background: #fff;

    .record-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
    .radio-group-buttons {
      margin-top: 10px;
    }
  }
</style>
